import { tv } from 'tailwind-variants'
import { SELECTED_TINT } from 'components/spreadsheet/components/cell/styles'
import { SMALL_ROW_HEIGHT_CLASS } from 'style/constants'

export const addRowGroupCellStyles = tv({
  base: `[border-right:1px_solid_var(--color-divider)] ${SMALL_ROW_HEIGHT_CLASS}`,
  variants: {
    frozen: {
      true: 'sticky z-[4]',
      false: 'relative'
    },
    lastFrozen: {
      true: 'shadow-[3px_0_1px_var(--color-divider)]',
      false: 'shadow-none'
    },
    inSelectedColumn: {
      true: SELECTED_TINT
    }
  }
})
